import React from 'react';
import type {SetRequired} from 'type-fest';
import type {UseFormReturn} from 'react-hook-form';
import {FormDialog, type FormDialogProps} from './FormDialog';

export interface ReactHookFormDialogProps
	extends SetRequired<FormDialogProps, 'onSubmit'> {
	form: UseFormReturn<any>;
}

export type ExtendReactHookFormDialogProps<P = {}> = P &
	Pick<ReactHookFormDialogProps, 'open' | 'onClose' | 'onSubmit'> & {
		FormProps?: Partial<Omit<FormDialogProps, 'DialogProps'>>;
		DialogProps?: Partial<FormDialogProps['DialogProps']>;
	};

export const ReactHookFormDialogPrimitive = ({
	form,
	...props
}: ReactHookFormDialogProps) => {
	return (
		<FormDialog
			error={form.formState.errors.root?.message}
			isDirty={form.formState.isDirty}
			isValid={form.formState.isValid}
			isSubmitting={form.formState.isSubmitting}
			{...props}
		/>
	);
};

/**
 * `react-hook-form` wrapper for `FormDialog`
 */
export const ReactHookFormDialog = ReactHookFormDialogPrimitive;

export default ReactHookFormDialog;
